import React from "react";
import { ReactComponent as LogoIcon } from "../../inlineSvgs/logo.svg";

const Banner = () => {
  return (
    <div className="banner__wrapper">
      <div className="banner" style={{ backgroundImage: `url(./img/BG.jpg)` }}>
        <div className="banner__logo">
          <LogoIcon />
        </div>
        <div className="banner__text">
          Put your personal beauty in the experienced hands of our team and enjoy a day full of relaxation and
          well-being.
        </div>
      </div>
    </div>
  );
};

export default Banner;
